import { Progress } from '@/components/ui/progress';
import type { BillingUsageSummary } from '@/api-types';

interface UsageSummaryProps {
	usage: BillingUsageSummary[];
}

const metricLabels: Record<string, string> = {
	builds: 'Builds',
	iterations: 'Iterations',
	hosted_apps: 'Hosted Apps',
};

export function UsageSummary({ usage }: UsageSummaryProps) {
	if (usage.length === 0) {
		return (
			<p className="text-sm text-text-tertiary">No usage data available.</p>
		);
	}

	return (
		<div className="space-y-4">
			{usage.map((item) => {
				const percentage = item.percentage ?? 0;
				const label = metricLabels[item.metric] || item.metric;
				const limitText = item.limit !== null ? `${item.currentUsage} / ${item.limit}` : `${item.currentUsage} (unlimited)`;

				return (
					<div key={item.metric} className="space-y-1">
						<div className="flex items-center justify-between text-sm">
							<span className="font-medium">{label}</span>
							<span className="text-text-secondary">{limitText}</span>
						</div>
						{item.limit !== null ? (
							<div className="relative">
								<Progress value={Math.min(percentage, 100)} className="h-2" />
								{item.isOverLimit && (
									<span className="text-xs text-red-500 mt-0.5 block">Over limit</span>
								)}
							</div>
						) : (
							<div className="h-2 rounded-full bg-blue-100 dark:bg-blue-950">
								<div className="h-full rounded-full bg-blue-500 w-[10%]" />
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
}
